// Highlights every team element (.team) whose text is exactly the given team name. An exact match is
// required: names such as "Svane" and "Svane 2" must not highlight each other.
export function setTeamHighlight(team: string, highlighted: boolean): void {
    if (!team) {
        return;
    }
    document.querySelectorAll<HTMLElement>('.team').forEach(element => {
        if (element.textContent?.trim() === team) {
            element.style.backgroundColor = highlighted ? 'yellow' : '';
        }
    });
}
